import axios from '@/libs/api.request'
// 导师申请保存 - Capacity
export const applyMentorCapacity = data => {
  return axios.request({
    url: '/apply/mentor/capacity',
    data,
    method: 'POST'
  })
}
// 导师申请 - sm步骤
export const applyMentorStepsSM = data => {
  return axios.request({
    url: '/apply/mentor/steps/smcm',
    data,
    method: 'GET'
  })
}
// 导师申请 - em步骤
export const applyMentorStepsEM = data => {
  return axios.request({
    url: '/apply/mentor/steps/em',
    data,
    method: 'GET'
  })
}
// 导师申请 - 保存 interview
export const applyMentorDiscuss = data => {
  return axios.request({
    url: '/apply/mentor/discuss',
    data,
    method: 'POST'
  })
}
// 导师申请 - 保存 contract
export const applyMentorContract = data => {
  return axios.request({
    url: '/apply/mentor/contract',
    data,
    method: 'POST'
  })
}
// 导师申请 - em written test
export const applyMentorWrittentest = data => {
  return axios.request({
    url: '/apply/mentor/writtentest',
    data,
    method: 'POST'
  })
}
